import { render } from "./Register.vue?vue&type=template&id=21041252"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/onboarding/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21041252"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21041252', __exports__)) {
    api.reload('21041252', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=21041252", () => {
    api.rerender('21041252', render)
  })

}


export default __exports__